export default __webpack_public_path__ + "static/media/schedule_call.b66c1ae9.svg";